if (!customElements.get("collections-carousel")) {
  class CollectionsCarousel extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      const swiperEl = this.querySelector(".swiper");
      if (!swiperEl) return;

      const options = {
        slidesPerView: 2,
        spaceBetween: 5,
        navigation: {
          nextEl: this.querySelector(".swiper-button-next"),
          prevEl: this.querySelector(".swiper-button-prev"),
        },
        pagination: {
          el: this.querySelector(".swiper-pagination"),
          clickable: true,
        },
        centerInsufficientSlides: true,
        breakpoints: {
          375: { slidesPerView: 2, spaceBetween: 5 },
          480: { slidesPerView: 3, spaceBetween: 5 },
          640: { slidesPerView: 4, spaceBetween: 10 },
          1024: { slidesPerView: 5, spaceBetween: 10 },
        },
      };

      this.swiper = new Swiper(swiperEl, options);
      swiperEl.classList.add("is-initialized");
    }
  }

  customElements.define("collections-carousel", CollectionsCarousel);
}
